import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { applyRequiredCapitalizations } from '../../util/TextUtils';
import { theme } from '../../../../themes';
import SafeConsole from '../../util/ConsoleUtils';

// Currently, ESLint complains on usage of spaces (instead of tabs). This will be fixed in next version, for now, disabling ESLint:
/* eslint-disable */

let TIMEZONES = [
  { name: 'PST', momentTz: 'PST', timezoneId: 'America/Los_Angeles', label: 'Pacific Standard Time' },
  { name: 'PDT', momentTz: 'PDT', timezoneId: 'America/Los_Angeles', label: 'Pacific Daylight Time', isDST: true },
  { name: 'CST', momentTz: 'CST', timezoneId: 'America/Chicago', label: 'Central Standard Time' },
  { name: 'CDT', momentTz: 'CDT', timezoneId: 'America/Chicago', label: 'Central Daylight Time', isDST: true },
  { name: 'EST', momentTz: 'EST', timezoneId: 'America/New_York', label: 'Eastern Standard Time' },
  { name: 'EDT', momentTz: 'EDT', timezoneId: 'America/New_York', label: 'Eastern Daylight Time', isDST: true },
  { name: 'MST', momentTz: 'MST', timezoneId: 'America/Phoenix', label: 'Mountain Standard Time' },
  { name: 'MDT', momentTz: 'MDT', timezoneId: 'America/Denver', label: 'Mountain Daylight Time', isDST: true },
  { name: 'AST', momentTz: 'AST', timezoneId: 'America/Puerto_Rico', label: 'Atlantic Standard Time' },
  { name: 'ADT', momentTz: 'ADT', timezoneId: 'America/Puerto_Rico', label: 'Atlantic Daylight Time', isDST: true },
  { name: 'AST', momentTz: 'AKST', timezoneId: 'America/Anchorage', label: 'Alaska Standard Time' },
  { name: 'ADT', momentTz: 'AKDT', timezoneId: 'America/Anchorage', label: 'Alaska Daylight Time', isDST: true },
  { name: 'HST', momentTz: 'HST', timezoneId: 'Pacific/Honolulu', label: 'Honolulu Standard Time' },
];

TIMEZONES = TIMEZONES.map((timezone) => ({ ...timezone, label: applyRequiredCapitalizations(timezone.label) }));

export default class TimeZonePicker extends Component {
  getTimezoneAlias = (ts) => {
    var result = [];
    for (var i = 0; i < TIMEZONES.length; i++) {
      var tzObj = TIMEZONES[i];
      if (tzObj.isDST) {
        if (
          moment(ts)
            .tz(tzObj.timezoneId)
            .isDST()
        ) {
          result.push(TIMEZONES[i]);
        }
      } else {
        if (
          !moment(ts)
            .tz(tzObj.timezoneId)
            .isDST()
        ) {
          result.push(TIMEZONES[i]);
        }
      }
    }
    return result;
  };

  render() {
    const tz = this.getTimezoneAlias(moment().valueOf());

    let selectClassName = 'gray'; // Default neutral color that would be OK for any partner.

    return (
      <div className={`timeZonePicker ${this.props.classes.formControl}`}>
        <label className="input-label" style={this.props.style}>
          {applyRequiredCapitalizations('TIME ZONE')}
        </label>
        <select
          name="timezone"
          defaultValue={this.props.defaultValue}
          onChange={this.props.onChange}
          id={this.props.id}
          disabled={this.props.isDisabled}
          className={selectClassName}
          {...this.props.selectProps}
        >
          <option value="choose" disabled>
            Please select
          </option>
          {tz.map((timezone) => {
            return (
              <option key={timezone.momentTz} value={timezone.timezoneId}>
                {timezone.label}
              </option>
            );
          })}
        </select>
      </div>
    );
  }
}

TimeZonePicker.propTypes = {
  defaultValue: PropTypes.string,
  classes: PropTypes.object,
  id: PropTypes.string,
  onChange: PropTypes.func,
  isDisabled: PropTypes.bool,
};

TimeZonePicker.defaultProps = {
  defaultValue: 'choose',
  classes: {},
  id: 'timezoneid',
  onChange: () => <div />,
  isDisabled: false,
};



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/components/common/TimeZonePicker.js